import VueHotjar from "vue-hotjar-next";
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueHotjar, {
        id: 3867111,
        isProduction: process.env.NODE_ENV === 'production',
        snippetVersion: 6
    })
})
